import { Center, Spinner, VStack } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { SectionTitle } from '../../../../../packages/ui/components/atoms/Title';

export function LoadingScreen({
  description,
  isOpen,
  loadingDelay,
}: {
  description: string;
  isOpen: boolean;
  loadingDelay: number;
}) {
  const loadingScreenRef = useRef<HTMLDivElement>(null);
  const [timeout, _setTimeout] = useState<NodeJS.Timeout>();
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (!loadingScreenRef.current) return;

    if (isOpen) {
      setHidden(true);
      loadingScreenRef.current.classList.remove('animate__fadeOut');
      loadingScreenRef.current.classList.add('animate__fadeIn', 'animate__faster');
    } else {
      loadingScreenRef.current.classList.remove('animate__fadeIn');
      _setTimeout(setTimeout(() => loadingScreenRef?.current?.classList.add('animate__fadeOut'), loadingDelay));
    }

    return clearTimeout(timeout);
  }, [isOpen]);

  if (hidden) return <></>;

  return (
    <Center
      ref={loadingScreenRef}
      className={'animate__animated'}
      position="fixed"
      top={'0px'}
      left={'0px'}
      width={'100%'}
      height={'100vh'}
      zIndex={1000}
      pointerEvents={'none'}
      backgroundColor={'secondaryColor'}
      transition={'1s'}
    >
      <VStack spacing={10}>
        <SectionTitle color={'secondaryFontColor'}>{description}</SectionTitle>
        <Spinner size="lg" color={'white'} />
      </VStack>
    </Center>
  );
}
